export default __webpack_public_path__ + "static/media/tabActHome.5ddde09d.svg";